<template>
    <footer>
      <div id="escalaGrisesFuncion_">
          <div id="footer" class="footer mt-auto footer-image footer-padding" style="background-color: #333;">
              <div class="alineacion">
                  <h3 class="m-0 p-0">
                      <i class="fas fa-phone-volume"></i>
                      <span class="bold300 mx-1">Asesoría fiscal</span>
                      <span class="bold900">¡Lada gratuita! 800 890 5920</span>
                  </h3>
              </div>
              <div class="container text-light" style="max-width:1250px !important;"> <!---style="margin-left:15%; margin-right: 15%;"-->
                  <div class="row"> <!----row-cols-1 row-cols-sm-2 row-cols-md-4-->
                      <div class="col logo-estado">
                          <img class="img-fluid" src="@/assets/imagenes/hacienda_chiapas.png">
                          <!-- <span class="mt-2" style="font-size: 0.8rem; color:#f8f9facc;"><p>Gobierno del Estado de Chiapas
                              Administración 2018-2024</p></span> -->
                      </div>
                      <div class="col-lg subtitulo-fotter"> <!--- puede ser col-md --->
                          <p>Enlaces de interés</p>
                          <div class="row px-3 mb-2">
                              <div class="col-6" style="border-top: 1px solid #621132;"></div>
                              <div class="col-6" style="border-top: 1px dotted grey;"></div>
                          </div>
                          <ul>
                              <!-- <li>
                                  <a href="https://www.chiapas.gob.mx/servicios-por-internet/#nav-1-1-personal">Instituto estatal del agua</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li> -->
                              <li class="margen-opciones">
                                  <a target="_blank" href="https://siem.economia.gob.mx/">SIEM</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <li class="margen-opciones"> <!---style="height:4rem;"---->
                                  <a target="_blank" href="http://www.coesmer.chiapas.gob.mx/">Comision Estatal de mejora Regulatoria</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                             <li class="margen-opciones">
                                  <a  target="_blank" :href="urlServe+'becas/becas.pdf'">Becas a Servidores Públicos</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <!-- <li class="margen-opciones">
                                  <router-link :to="{name: 'enlaces-de-interes'}" >Otros enlaces</router-link>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li> -->

                              <!-- <li>
                                  <a href="https://www.chiapas.gob.mx/servicios-por-internet/#nav-1-1-empresarial">Empresas</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <li>
                                  <a href="https://www.chiapas.gob.mx/servicios-pago-de-derechos/">Pago de Derechos</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li> -->
                          </ul>
                      </div>
                      <div class="col-lg subtitulo-fotter">
                          <p>Recursos</p>
                          <div class="row px-3 mb-2">
                              <div class="col-6" style="border-top: 1px solid #621132;"></div>
                              <div class="col-6" style="border-top: 1px dotted grey;"></div>
                          </div>
                          <ul>
                              <!-- <li>
                                  <a target="_blank" href="https://www.chiapas.gob.mx/acerca">Acerca del Portal</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li> -->
                              <li>
                                  <!-- <a href="https://www.chiapas.gob.mx/privacidad">Avisos de Privacidad</a> -->
                                  <router-link :to="{name: 'aviso-de-privacidad'}">Avisos de Privacidad</router-link>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <!-- <li>
                                  <a target="_blank" href="https://www.chiapas.gob.mx/contacto">Contáctanos</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li> -->
                              <!--<li>
                                  <a target="_blank" href="https://outlook.office.com/">
                                  Correo institucional</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>-->
                              <li>
                                  <!-- <router-link :to="{name: 'conocenos-directorio-secretaria-de-hacienda'}"> -->
                                    <a href="https://www.chiapas.gob.mx/funcionarios/estatal/ejecutivo/secretaria-finanzas" target="_blank">
                                      Directorio de funcionario
                                    </a>
                                  <!-- </router-link> -->
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <li>
                                  <router-link :to="{name: 'modulo-planeacion'}">
                                  Manual de Formatos</router-link>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <div class="" style="/*border-bottom: 1px dotted gray !important;*/">
                                  <router-link :to="{name: 'TramitesHaciendaExternos'}">
                                      <img class="" src="@/assets/imagenes/button_tramites_externos.png" style="border-radius:6px;">
                                  </router-link>
                              </div>
                          </ul>
                      </div>
                      <div class="col-lg subtitulo-fotter">
                          <p>Transparencia</p>
                          <div class="row px-3 mb-2">
                              <div class="col-6" style="border-top: 1px solid #621132;"></div>
                              <div class="col-6" style="border-top: 1px dotted grey;"></div>
                          </div>
                          <ul>
                              <li class="margen-opciones">
                                  <a target="_blank" :href="'http://www.transparencia.'+urlSubdominio">Transparencia Fiscal</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <li class="margen-opciones">
                                  <a target="_blank" :href="urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2026.PDF'">Ley de Ingresos 2026</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                              <li class="margen-opciones pb-3">
                                  <a target="_blank" :href="urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto26.PDF'">Presupuesto de Egresos 2026</a>
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </li>
                          </ul>
                      </div>
                      <div class="col-lg subtitulo-fotter">
                          <p>Ubicación</p>
                          <div class="row px-3 mb-2">
                              <div class="col-6" style="border-top: 1px solid #621132;"></div>
                              <div class="col-6" style="border-top: 1px dotted grey;"></div>
                          </div>

                          <span class="mt-2" style="font-size: 0.8rem; color:#f8f9facc; border-bottom: none;">
                            <p>
                                Secretaría de Finanzas - Chiapas
                                Blvd. Andrés Serra Rojas No. 1090, Torre Chiapas,
                                Col. Paso Limón, C.P. 29049,
                                Tuxtla Gutiérrez, Chiapas
                            </p>
                          </span>
                      </div>
                      <div class="col-lg subtitulo-fotter">
                          <div class="row">
                              <div class="col-lg text-center">
                                  <!-- <a target="_blank" href="http://itaipchiapas.org.mx/"><img class="img-fluid img-fluid_" src="@/assets/imagenes/ban3_.png" style="border-radius:6px;"></a> -->
                                  <a target="_blank" href="https://anticorrupcionybg.gob.mx/transparenciapueblo/"><img class="img-fluid img-fluid_" src="@/assets/imagenes/TPCH.png" style="border-radius:6px;"></a>
                                  <a target="_blank" href="https://www.plataformadetransparencia.org.mx/web/guest/inicio"><img class="img-fluid img-fluid_ my-3" src="@/assets/imagenes/transparencia.png"></a>
                                  <a target="_blank" href="https://consultapublicamx.plataformadetransparencia.org.mx/?v=a&e=7&y=2026&s=1213"><img class="img-fluid img-fluid_" src="@/assets/imagenes/inai.png"></a>
                                  <a target="_blank" href="https://outlook.office.com/"><img class="img-fluid img-fluid_ my-3" src="@/assets/imagenes/correo.png"></a>
                              </div>
                              <!-- <div class="col-6 pl-1 d-flex align-items-center">.
                              </div> -->
                          </div>
                      </div>
                      <!-- <div class="col-lg tramites-externos px-0">
                          <div class="row">
                              <div class="col-lg text-center">
                                  <router-link :to="{name: 'TramitesHaciendaExternos'}">
                                      <img class="img-fluid img-fluid_" src="@/assets/imagenes/button_tramites_externos.png" style="border-radius:6px;">
                                  </router-link>
                              </div>
                          </div>
                      </div> -->

                  </div>
              </div>
          </div>

          <!-- NAV DEL GOBIERNO DEL ESTADO -->
          <div class="footer mt-auto d-flex justify-content-between" style="background-color: #000; padding-top:0.6rem; padding-bottom:0.6rem;">
            <div class="container" style="max-width: 1400px;">
              <div class="row">
                <div class="col-sm">
                    <span class="text-light gob__">Gobierno del Estado de Chiapas </span>
                </div>
                <div class="col-sm align-redes">
                    <div class="redes-icons col-md-2">
                      <ul class="list-inline text-center text-md-right mb-0 d-flex justify-content-evenly">
                          <li class="li_"> <a target="_blank" href="https://www.facebook.com/sfchiapasoficial">
                            <i class="fab fa-facebook-f"></i>
                            </a></li>
                          <li class="li_"><a target="_blank" href="https://www.instagram.com/sfchiapasoficial">
                            <i class="fab fa-instagram"></i>
                            </a></li>
                          <li class="li_"><a target="_blank" href="https://twitter.com/Sfpchiapas">
                            <i class="fab fa-twitter"></i>
                          </a></li>
                      </ul>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <accesibilidad-vue />
        <!-- CHAT -->
        <div class="chat">
            <a :href="'http://ayuda.ingresos.'+urlSubdominio+'webim/client.php?locale=sp'" target="_blank" class="contenedor-chat text-center">
                <span class="texto-chat">Atención al <br> contribuyente</span>
            </a>
        </div>
    </footer>
</template>

<script>
import accesibilidadVue from "./accesibilidad.vue";
export default ({
  components: {accesibilidadVue},
  data: function() {
    return{    }
  },
  methods:{  }
})
</script>


<style scoped>
.gob__{
    font-size: .89rem !important;
    color: #bebebe !important;
  }

ul .li_{
  width: 1.5rem; /*24px;*/
  height: 1.375rem; /*22px;*/
  border-radius: 1px;
  padding: 0 !important;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background: #303030;
  color: #acacac;
  display: flex;
  justify-content: center  !important;
  align-items: center;
}
ul li a{
  display: flex;
  align-items: center;
  padding-top: .1rem;
}
ul li a i{ font-size: .6rem; }
.redes-icons{   margin-top: .21rem !important; }
.redes-icons ul li:hover{background: #474747;}
.redes-icons ul li a:hover{ text-decoration: none;}
.align-redes{ display: flex; justify-content: flex-end; }

.alineacion{
    width:100%;
    display:flex;
    justify-content:center;
    margin-bottom:3rem;
    color:white;
    text-align: center;
}
 .tramites-externos{display: flex;align-items: center; justify-content: center;}

.chat a{
    position: fixed;
    z-index: 10000;
    right: 2%;
    bottom: 5.6%;
    font-size: 3rem;
    color: white;
    background: #009886; /* #309030; /*#219e61;*/
    /* border-radius: 31%; */
    /* width: 5rem; */
    /* height: 5rem; */
    padding: 1rem 1rem;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    border-top-right-radius: 30px;
}
/* .accesibilidad{
    position: fixed;
    z-index: 10000;
    right: 2%;
    bottom: 16%;
    padding: 1rem 1rem;
} */
.chat a:hover{ text-decoration: none; }
.texto-chat{ font-size:.89rem; line-height: .99rem; }

.contenedor-chat {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* .chat-desplegado { position:fixed; z-index: 10000; right:1%; bottom:10%; } */

  /* iframe {  width: 100%; } */

    /* .output { border: none; background: transparent; } */

    /* padding del footer en resoluciones < 1920x1200 */
    .footer-padding{
      padding-top:13rem;
      padding-bottom: 3.2rem;
    }
     @media only screen and (min-device-width : 1921px) {
        .footer-padding{ padding-top:20rem; }
     }

    .img-fluid_ { max-width: 92%; }
    .margen-opciones{padding-top: .9rem;}

    @media only screen and (max-device-width : 900px) {
        .img-fluid_ { max-width: 74%; }
        .chat a{ padding: .4rem .5rem; font-size: 1.8rem; }
        .texto-chat{ font-size:.8rem; line-height: 1rem; }
        .align-redes{ display: flex; justify-content: center;}
        .redes-icons{ padding: .5rem 0; }
    }

</style>
